import { render, staticRenderFns } from "./DosageHospital-form.vue?vue&type=template&id=0f606251&scoped=true&"
import script from "./DosageHospital-form.vue?vue&type=script&lang=js&"
export * from "./DosageHospital-form.vue?vue&type=script&lang=js&"
import style0 from "./DosageHospital-form.vue?vue&type=style&index=0&id=0f606251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f606251",
  null
  
)

export default component.exports